module.exports = __webpack_public_path__ + "static/media/selectedGaugeIcon.2343d3d9.png";